// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';

import Wallet from '../../../ui-component/Wallet';
import Logo from 'ui-component/Logo';
import { FaDiscord, FaTwitter } from 'react-icons/fa';
import config from 'config.js';
import ChainSwitcher from 'ui-component/ChainSwitcher';
import { useWallet } from 'hooks/useWallet';
import styled from '@emotion/styled';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const { active, chainId, switchChain } = useWallet();

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: '100%',
          boxShadow: '0 2px 14px 0 rgb(0 0 0 / 50%)',
          backgroundColor: 'dark.main',
          padding: '5px 30px',
          display: 'flex',
          alignItems: 'center',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          },
          justifyContent: 'space-between'
        }}
      >
        <Box component="span">
          <Link href="/">
            <Logo width="70px" />
          </Link>
        </Box>
        {/* <Typography variant="h1">MINING</Typography> */}
        <HeaderButtons>
          {active && <ChainSwitcher />}
          <Wallet />
          {/* {config.discord && (
            <Link href={config.discord} target="_blank">
              <FaDiscord size="1.8rem" color={theme.palette.text.secondary} />
            </Link>
          )}

          {config.twitter && (
            <Link href={config.twitter} target="_blank">
              <FaTwitter size="1.8rem" color={theme.palette.text.secondary} />
            </Link>
          )} */}
        </HeaderButtons>
      </Box>
    </>
  );
};

const HeaderButtons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  & > * {
    margin: 10px 10px;
  }
`;

export default Header;
